"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  PopoverBase: true
};
exports.default = exports.PopoverBase = void 0;
var _chainFunction = _interopRequireDefault(require("chain-function"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _focusManager = require("../utils/focusManager");
var _Icon = require("../Icon/Icon");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _IconButton = require("../IconButton/IconButton");
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _Popper = require("../utils/_Popper");
var _useOnClickOutside = require("../utils/_useOnClickOutside");
var _PopoverBase = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./PopoverBase.css") : void 0);
var _PopoverBase2 = require("./_PopoverBase.types");
Object.keys(_PopoverBase2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _PopoverBase2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _PopoverBase2[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable react/jsx-max-props-per-line */

const CSS_BLOCK = 'sapcnqr-popover';
const PopoverBase = exports.PopoverBase = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const _a = addChildProps ? Object.assign(Object.assign({}, props), addChildProps(PopoverBase, props)) : props,
    {
      additionalTitleContentStart,
      additionalTitleContentEnd,
      titleContentStartContainerProps,
      titleContentEndContainerProps,
      arrowClassName,
      disableHideWhenTargetIsHidden,
      children,
      className,
      flipContainer,
      footer,
      footerProps,
      hideCloseButton,
      id,
      message,
      offset = 10,
      placement = ['right', 'left', 'top', 'bottom'],
      popperContentProps,
      popperMiddleware,
      popperProps,
      show: showProp = false,
      skidding,
      targetProps,
      textClose,
      title,
      titleBarClassName,
      titleClassName,
      onCloseClicked,
      onHide,
      targetClassName,
      type,
      width
    } = _a,
    otherProps = __rest(_a, ["additionalTitleContentStart", "additionalTitleContentEnd", "titleContentStartContainerProps", "titleContentEndContainerProps", "arrowClassName", "disableHideWhenTargetIsHidden", "children", "className", "flipContainer", "footer", "footerProps", "hideCloseButton", "id", "message", "offset", "placement", "popperContentProps", "popperMiddleware", "popperProps", "show", "skidding", "targetProps", "textClose", "title", "titleBarClassName", "titleClassName", "onCloseClicked", "onHide", "targetClassName", "type", "width"]);
  const [show, setShow] = (0, _react.useState)(showProp);
  const previousShowRef = (0, _react.useRef)(showProp);
  const popoverRef = (0, _react.useRef)(null);
  const _focusManagerRef = (0, _react.useRef)(null);
  const targetRef = (0, _react.useRef)(null);
  let uniqueId = (0, _useUniqueId.default)();
  if (id) {
    uniqueId = id;
  }
  (0, _react.useEffect)(() => {
    setShow(showProp);
  }, [showProp]);
  (0, _react.useEffect)(() => {
    var _a;
    if (previousShowRef.current && !show) {
      onHide === null || onHide === void 0 ? void 0 : onHide();
      (_a = targetRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      _focusManagerRef.current = null;
    }
    previousShowRef.current = show;
  }, [show]);
  const handleClickOutside = e => {
    var _a;
    if (e && ((_a = popoverRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
      return;
    }
    setShow(false);
  };
  (0, _useOnClickOutside.useOnClickOutside)({
    ref: popoverRef,
    handleClickOutside,
    show
  });
  const _handleFocusManager = () => {
    if (show && popoverRef.current && !_focusManagerRef.current) {
      _focusManagerRef.current = new _focusManager.FocusManager({
        trapNode: popoverRef.current
      });
    }
  };
  const _onCloseClicked = e => {
    setShow(false);
    onCloseClicked === null || onCloseClicked === void 0 ? void 0 : onCloseClicked(e);
  };
  const _handleClick = () => {
    setShow(true);
  };
  const classnames = _bind.default.bind(_PopoverBase.default);
  const popperClassName = classnames(CSS_BLOCK, className, {
    [`${CSS_BLOCK}--custom-size`]: !!width
  });
  let popperStyleProps = popperProps === null || popperProps === void 0 ? void 0 : popperProps.style;
  if (width) {
    popperStyleProps = Object.assign(Object.assign({}, popperStyleProps), {
      width
    });
  }
  const passChildProps = (child, childProps) => {
    if (child.displayName === 'Toolbar') {
      return {
        className: classnames(`${CSS_BLOCK}__toolbar`, childProps === null || childProps === void 0 ? void 0 : childProps.className),
        toolbarStyle: 'transparent'
      };
    }
    return null;
  };
  const extendedPopperProps = Object.assign(Object.assign({
    'aria-describedby': `${uniqueId}-content`,
    'aria-labelledby': `${uniqueId}-title`,
    'data-testid': uniqueId,
    id: uniqueId,
    role: 'dialog'
  }, popperProps), {
    style: popperStyleProps
  });
  const child = _react.default.Children.only(children);
  const mergedChildRef = (child === null || child === void 0 ? void 0 : child.ref) ? (0, _reactMergeRefs.default)([child === null || child === void 0 ? void 0 : child.ref, targetRef]) : targetRef;
  const targetComponent = child && /*#__PURE__*/_react.default.cloneElement(child, {
    'aria-controls': show ? uniqueId : null,
    'aria-expanded': show,
    'aria-haspopup': 'dialog',
    onClick: (0, _chainFunction.default)(_handleClick, child === null || child === void 0 ? void 0 : child.props.onClick),
    ref: mergedChildRef
  });
  const _b = popperContentProps || {},
    {
      className: popperContentClassName
    } = _b,
    otherPopperContentProps = __rest(_b, ["className"]);
  return /*#__PURE__*/_react.default.createElement(_Popper.Popper, {
    arrowClassName: classnames(`${CSS_BLOCK}__arrow`, arrowClassName),
    disableHideWhenTargetIsHidden: disableHideWhenTargetIsHidden,
    flipContainer: flipContainer,
    offset: offset,
    skidding: skidding,
    onEscapeKey: _onCloseClicked,
    popperClassName: popperClassName,
    popperContentProps: Object.assign(Object.assign({}, otherPopperContentProps), {
      className: classnames(`${CSS_BLOCK}__wrapper`, popperContentClassName)
    }),
    popperMiddleware: popperMiddleware,
    popperPlacement: placement,
    popperProps: extendedPopperProps,
    show: show,
    showArrow: true,
    targetClassName: targetClassName,
    targetComponent: targetComponent,
    targetProps: targetProps
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__dialog`),
    ref: (0, _reactMergeRefs.default)([ref, popoverRef, _handleFocusManager])
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__titlebar`, {
      [`${CSS_BLOCK}__titlebar--wrap`]: additionalTitleContentEnd
    }, titleBarClassName)
  }, /*#__PURE__*/_react.default.createElement("div", Object.assign({}, titleContentStartContainerProps, {
    className: classnames(`${CSS_BLOCK}__title-content`, titleContentStartContainerProps === null || titleContentStartContainerProps === void 0 ? void 0 : titleContentStartContainerProps.className)
  }), additionalTitleContentStart, type && (/*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    ariaHidden: true,
    className: classnames(`${CSS_BLOCK}__icon`),
    iconName: `messaging-${type}`
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: classnames(`${CSS_BLOCK}__title`, titleClassName),
    id: `${uniqueId}-title`
  }, title)), (additionalTitleContentEnd || !hideCloseButton) && (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, titleContentEndContainerProps, {
    className: classnames(`${CSS_BLOCK}__title-content`, titleContentEndContainerProps === null || titleContentEndContainerProps === void 0 ? void 0 : titleContentEndContainerProps.className)
  }), additionalTitleContentEnd, !hideCloseButton && (/*#__PURE__*/_react.default.createElement(_IconButton.IconButton, Object.assign({
    ariaLabel: textClose
  }, otherProps, {
    iconName: "close",
    iconProps: Object.assign(Object.assign({}, otherProps.iconProps), {
      forceSize: 'xs-plus'
    }),
    onClick: _onCloseClicked
  })))))), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(`${CSS_BLOCK}__content`),
    id: `${uniqueId}-content`
  }, message), footer && (/*#__PURE__*/_react.default.createElement("div", Object.assign({}, footerProps, {
    className: classnames(`${CSS_BLOCK}__footer`, footerProps === null || footerProps === void 0 ? void 0 : footerProps.className)
  }), /*#__PURE__*/_react.default.createElement(_AddChildPropsContext.AddChildPropsProvider, {
    value: passChildProps
  }, footer)))));
});
PopoverBase.displayName = 'PopoverBase';
var _default = exports.default = PopoverBase;